<template>
  <!-- 协会领导详情 -->
  <div id="ContactInfodetail" class="ContactInfodetail">
    <Header></Header>
    <Navigate></Navigate>
    <div class="ContactInfodetailConent">
      <div class="crumbs">
        <i class="iconfont icon-zhuye"></i>
        <span><router-link :to="{name:'home'}">首页</router-link></span>

        <i class="iconfont icon-youjiantou"></i>
        <span><router-link :to="{name:'ContactInfo'}">专委会</router-link></span>
        <i class="iconfont icon-youjiantou"></i>
        <span><a>专委会详情</a></span>
      </div>
      <div class="content_body">
        <div class="content_body_left">
          <BannerLeft></BannerLeft>
        </div>
        <div class="content_body_right">
          <p v-html="ContactInfodetaildetail.Title"></p>
          <p><span>{{ContactInfodetaildetail.AddDate}}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>来源：{{ContactInfodetaildetail.Source}}</span>
          </p>
          <p v-html="ContactInfodetaildetail.Content"></p>
        </div>
        <div style="clear:both;"></div>
      </div>
    </div>
    <Foot></Foot>
	</div>
</template>

<script>
import router from '@/router/index'
import Header from '@/components/public/heade/index'
import Navigate from '@/components/public/navigation/index'
import Foot from '@/components/public/foot/index'
import BannerLeft from '@/components/public/bannerLeft/index'
import axios from 'axios'
export default {
	name:'ContactInfodetail',
	data(){
		return{
      ContactInfodetaildetail:[]
		}
  },
  components:{
    Header,
    Navigate,
    Foot,
    BannerLeft
	},
	methods:{
		getData(){
			axios.post('/SiteContentAPI/GetModel',{
        ContentID:this.$route.query.id
      }).then((res) => {
				this.ContactInfodetaildetail = res.data //_itemList是上面那个结构体
				this.ContactInfodetaildetail.AddDate = this.ContactInfodetaildetail.AddDate.substr(0,10)
        this.ContactInfodetaildetail.AddDate = this.ContactInfodetaildetail.AddDate.replace(/-/,'年').replace(/-/,'月') + "日";
			})
		}
	},
	created(){
    this.getData();
    let pid = this.$route.query.id;
    if(pid){
      this.initOther(id);
    }
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    '$route'(to,from) {
      //做一些路由变化的响应
      //打开加载动画
      this.loading = true;
      //重新获取数据
      this.getData();
      /** 初始化其他数据 */
      let pid = this.$route.query.id;
      if(pid){
        this.initOther(id);
      }
    },
  }
}
</script>

<style lang="less" scoped>
  #ContactInfodetail{
    width:100%;
    height:auto;
    .ContactInfodetailConent{
      width:1200px;
      margin:0 auto;
      height:100%;
      position: relative;
      .crumbs{
        width:1200px;
        height:20px;
        position:relative;
        text-align:left;
        margin-top:24px;
        margin-left: 2%;
        line-height:20px;
        span:nth-child(2) a{
          color:#000000;
          font-size:16px;
          font-weight:bold;
          cursor:pointer;
        }
        i{
          color:#767C82;
          font-size:18px;
          margin-left:10px;
          font-weight:bold;
        }
        i:nth-child(1){
          color:#000;
          margin-right:5px;
        }
        span:nth-child(4) a{
          color:#000000;
          font-size:16px;
          margin-left:10px;
          font-weight:bold;
          cursor:pointer;
        }
        span:nth-child(6) a{
          color:#000000;
          font-size:16px;
          margin-left:10px;
          font-weight:bold;
          cursor:pointer;
        }
         span:nth-child(8) a{
          color:#C01B22;
          font-size:16px;
          margin-left:10px;
          font-weight:bold;
          cursor:pointer;
        }
      }
      .content_body{
         width: 1130px;
    height: 100%;
    margin-left: 3%;
    margin-top: 20px;
    border: 1px solid #bbbbbb;
        padding-left: 30px;
    padding-right: 30px;
        // .content_body_left{
        //   width:280px;
        //   height:100%;
        //   float:left;
        // }
        .content_body_right{
          width: 1130px;
        height: auto;
        // margin-left: 3%;
          // float:right;
          // margin-left:15px;
          margin-top:24px;
          p:nth-child(1){
            text-align:center;
            font-size:24px;
            color:#000;
          }
          p:nth-child(2){
            text-align:center;
            font-size:16px;
            color:#000;
            margin-top:10px;
          }
          p:nth-child(3){
            font-size:18px;
            color:#000;
            margin-top:26px;
            text-indent:2em;
            text-align:center;
            line-height:33px;
            text-align: justify;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Assocwindow/ContactInfo/ContactInfodetail/index.vue